import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Los antiácidos comunes',
    desc: 'Detienen la digestión por completo, haciendo que la comida se pudra en el estómago y cause más gas a largo plazo.'
  }, {
    title: "Las dietas de 'hospital'",
    desc: '(Pollo hervido y arroz) son imposibles de mantener porque eliminan el placer y la cultura de tu mesa.'
  }, {
    title: 'Beber agua helada',
    desc: 'Durante las comidas diluye lo poco que te queda de jugos gástricos, empeorando la inflamación.'
  }, {
    title: 'Dormir con tres almohadas',
    desc: 'Solo disfraza el problema mecánico sin resolver la causa química interna.'
  }];
  return <SectionWrapper bgColor="white" data-id="element-15">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-forest text-center mb-12" data-id="element-16">
        Por qué lo que has intentado no funciona
      </h2>

      <div className="grid gap-6 md:grid-cols-2" data-id="element-17">
        {failures.map((item, index) => <div key={index} className="flex gap-4 p-6 rounded-2xl bg-gray-50 border border-gray-100" data-id="element-18">
            <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-19" />
            <div data-id="element-20">
              <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-21">
                {item.title}
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-22">
                {item.desc}
              </p>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}